import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {
  validateNRIC,
  validatePassport,
  validatePhone,
  validateEmail,
  validatePostal,
  validateWhiteSpace,
  validateCapitalLetter,
} from './utils/customValidator';

for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
  });
}

extend('nric', validateNRIC);
extend('passport', validatePassport);
extend('phone', validatePhone);
extend('email', validateEmail);
extend('postal', validatePostal);
extend('whitespace', validateWhiteSpace);
extend('capital', validateCapitalLetter);
